import { render } from "./Index2.vue?vue&type=template&id=59273cae&scoped=true"
import script from "./Index2.vue?vue&type=script&lang=js"
export * from "./Index2.vue?vue&type=script&lang=js"

import "./Index2.vue?vue&type=style&index=0&id=59273cae&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59273cae"]])

export default __exports__